export function flashEffect(ctrl, message, element = null) {
  const el = element || ctrl.element
  const effects = ctrl.application.getControllerForElementAndIdentifier(
    el,
    'effects'
  )
  effects.flash({ detail: message })
}
